import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {
  activeSection: string;

  constructor(private router: Router) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activeSection = event.url.includes('sample') ? 'sample-courses' : 'courses';
      }
    })
  }
  @ViewChild('courses', { read: ElementRef }) public courses: ElementRef<any>;

  @Input() category: any;
  @Input() courseList: any;
  ngOnInit(): void {
  }

  public scrollRight(): void {
    if (window.innerWidth > 600)
      this.courses.nativeElement.scrollTo({ left: (this.courses.nativeElement.scrollLeft + 350), behavior: 'smooth' });
    else
      this.courses.nativeElement.scrollTo({ left: (this.courses.nativeElement.scrollLeft + 311), behavior: 'smooth' });

  }

  public scrollLeft(): void {
    if (window.innerWidth > 600)
      this.courses.nativeElement.scrollTo({ left: (this.courses.nativeElement.scrollLeft - 350), behavior: 'smooth' });
    else
      this.courses.nativeElement.scrollTo({ left: (this.courses.nativeElement.scrollLeft - 311), behavior: 'smooth' });

  }

  onClickCourse(id) {
    sessionStorage.setItem('activeSection', JSON.stringify(this.activeSection))
    this.router.navigate(['courses/details/' + id]);
  }
}
